module.exports = __webpack_public_path__ + "static/img/img4.14714a10.png";